// Phase 1C: per-input provenance chips. One badge per input
// category (springs, motion_ratio, damper_fv, ...) showing
// PASS | FALLBACK | ABSENT with the reason on hover.
//
// Renders the api_models.ProvenanceSummary shape — the same one
// the backend builds via build_provenance_report and serialises
// into run_artifacts.provenance.
import type { ProvenanceSummary } from "../api/tests";

const CHIP_COLORS: Record<"PASS" | "FALLBACK" | "ABSENT", { bg: string; fg: string }> = {
  PASS: { bg: "#1f3d1f", fg: "#7ed47e" },
  FALLBACK: { bg: "#4a3a1f", fg: "#e4c47a" },
  ABSENT: { bg: "#3a3a3a", fg: "#9a9a9a" },
};

export type ProvenanceChipsProps = {
  summary: ProvenanceSummary;
};

export function ProvenanceChips({ summary }: ProvenanceChipsProps) {
  const entries = Object.entries(summary.inputs).sort(([a], [b]) => a.localeCompare(b));
  return (
    <div
      data-testid="provenance-chips"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginTop: "8px",
      }}
    >
      {entries.map(([name, status]) => {
        const colors = CHIP_COLORS[status.status];
        const label = `${name}: ${status.status}`;
        return (
          <span
            key={name}
            title={status.reason ?? `${name} input is ${status.status}`}
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "11px",
              fontWeight: 500,
              backgroundColor: colors.bg,
              color: colors.fg,
              fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, monospace",
            }}
            data-status={status.status}
          >
            {label}
          </span>
        );
      })}
    </div>
  );
}
